import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/store';
// import posthog from 'posthog-js';

// posthog.init('phc_9GG30O50UMU5puyhtQ6yjWKP22ma8AYJSsACeOVftgz', { api_host: 'https://app.posthog.com' })


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <Provider store={store}>
      <App />
    </Provider>
);

